import { inject, Injectable } from '@angular/core';
import { propertyLazySelectChangeRrcLimit } from "../configs/change-rrc-limit-modal-config";
import { RecordTableApiService } from "../../../../../../../core/services-api/record-table-api.service";
import { GetSelectDataParams, SelectData } from "../../../../../../../core/types/records-table.types";

@Injectable({
  providedIn: 'root'
})
export class ChangeRrcLimitModalService {
  private recordTableApiService: RecordTableApiService = inject(RecordTableApiService);

  public fetchSelectData(id: number): Promise<Array<SelectData>> {
    const getSelectDataParams: GetSelectDataParams = {
      propertyLazySelect: propertyLazySelectChangeRrcLimit,
      id: id
    };

    return new Promise((resolve, reject) => {
      this.recordTableApiService.fetchSelectData(getSelectDataParams).subscribe({
        next: (selectData: Array<SelectData>) => resolve(selectData),
        error: (error) => reject(error)
      });
    });
  }
}
